import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { RestaurantService } from '../../../services/Restaurant.service';
import { AmenitiesFormComponent } from './amenities-form/amenities-form.component';

@Component({
  selector: 'app-amenities',
  templateUrl: './amenities.component.html'
})
export class AmenitiesComponent implements OnInit {

  dataLoading = false;
  @Input() restaurantId: any;

  // Nav scrollable
  mouseDown = false;
  startX: any;
  scrollLeft: any;
  slider!: any;
  amenitiesData: any;
  amenitiesList: any[] = [];

  constructor(public dialog: MatDialog,
    private service: RestaurantService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    if (!this.restaurantId) {
      this.route.params.subscribe(params => {
        this.restaurantId = params['id'];
      });
    }
    this.GetAmenities()

  }
  initSlider() {
    this.slider = document.querySelector<HTMLElement>('#amenities-slider');
  }

  startDragging(e?: any, flag?: any) {
    this.mouseDown = true;
    this.startX = e.pageX - this.slider!.offsetLeft;
    this.scrollLeft = this.slider!.scrollLeft;
  }
  stopDragging(e?: any, flag?: any) {
    this.mouseDown = false;
  }
  moveEvent(e?: any) {
    e.preventDefault();
    if (!this.mouseDown) {
      return;
    }
    const x = e.pageX - this.slider!.offsetLeft;
    const scroll = x - this.startX;
    this.slider!.scrollLeft = this.scrollLeft - scroll;
  }

  GetAmenities() {
    this.dataLoading = true;
    this.service.GetRestaurantAmenities(this.restaurantId).subscribe((data: any) => {
      this.dataLoading = false;
      this.amenitiesData = data;
      this.amenitiesList = data.restaurantAmenitiesDto;
      setTimeout(() => {
        this.initSlider();
      }, 100);
    })
  }

  openAmenitiesForm() {
    const dialogRef = this.dialog.open(AmenitiesFormComponent, {
      width: '50rem',
      data: { selectedItems: this.amenitiesList, restaurantId: this.restaurantId }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.GetAmenities()
      }
    });
  }
}
